import { A2PRegistrationModal } from '@forwardflow/modals/A2PRegistrationModal'
import { LaunchHome } from '@forwardflow/modules/onboarding/home/LaunchHome'

interface IGetStartedProps {
   isCalendarConnected: boolean
   onConnectCalendar: () => void
}

/**
 * The dashboard home until the first campaign is live: the launch page
 * (describe who to call, or pick a campaign built from the account), with
 * texting approval, the calendar and the assistant connection underneath.
 */
export const GetStarted = ({ isCalendarConnected, onConnectCalendar }: IGetStartedProps) => (
   <>
      <LaunchHome isCalendarConnected={isCalendarConnected} onConnectCalendar={onConnectCalendar} />
      <A2PRegistrationModal />
   </>
)
